@if (showEdit) {
    <div class="page page--form">
        <app-formulario
            [title]="'Editar asociado'"
            [buttons]="buttons"
            [fields]="fields"
            [type]="type"
            [functionSelected]="FunctionsAvailable.asociadosPut">
        </app-formulario>
    </div>
} @else {
    <div class="page">
        @if (error) {
            <div class="state-panel state-panel--error" role="alert" data-testid="ficha-error">
                <i class="bi bi-exclamation-octagon-fill state-panel__icon" aria-hidden="true"></i>
                <p class="state-panel__title">No se ha podido mostrar la ficha</p>
                <p class="state-panel__text">{{ error }}</p>
                <span class="cluster justify-content-center mt-2">
                    <button type="button" class="btn btn-outline-danger" data-testid="ficha-reintentar" (click)="cargar()"><i class="bi bi-arrow-clockwise" aria-hidden="true"></i>Reintentar</button>
                    <button type="button" class="btn btn-secondary" data-testid="ficha-volver" (click)="volverAlListado()">Volver al listado</button>
                </span>
            </div>
        } @else if (loading || !item) {
            <app-spinner [fullscreen]="false"></app-spinner>
        } @else {
            <section class="ficha-hero" data-seccion="asociados" aria-labelledby="ficha-titulo">
                <div class="ficha-hero__back">
                    <button type="button" class="back-link" (click)="goBack({mode: 'showItem', item: parent, type: 'Ejercicios'})"><i class="bi bi-arrow-left" aria-hidden="true"></i>Volver</button>
                </div>
                <div class="ficha-hero__top">
                    @if (tieneFoto(item.img)) {
                        <img [src]="filesBasePath + item.img" class="ficha-hero__photo" [alt]="'Foto de ' + item.nombre" width="96" height="96">
                    } @else if(!item.ejercicio) {
                        <img src="assets/img/default.png" class="ficha-hero__photo" alt="Sin foto" width="96" height="96">
                    }
                    <div class="ficha-hero__id">
                        <h1 id="ficha-titulo">{{ item.nombre | titlecase }} {{ item.apellidos | titlecase }}</h1>
                        <p class="meta">Ficha de asociado</p>
                    </div>
                    <div class="ficha-hero__actions">
                        @if (viewMode === ViewModeAsociado.CHANGE_PASSWORD) {
                            <button type="button" class="btn btn-outline-secondary" (click)="viewMode = ViewModeAsociado.CONTACT"><i class="bi bi-person-vcard" aria-hidden="true"></i>Volver a la ficha</button>
                        } @else {
                            <div class="dropdown">
                                <button class="btn btn-outline-primary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false" data-testid="menu-acciones-asociado">
                                    <i class="bi bi-three-dots-vertical" aria-hidden="true"></i>Acciones
                                </button>
                                <ul class="dropdown-menu dropdown-menu-end">
                                    <li><button type="button" class="dropdown-item" (click)="editItem()"><i class="bi bi-pencil-square" aria-hidden="true"></i>Editar</button></li>
                                    <li><button type="button" class="dropdown-item" (click)="router.navigate(['/asociado/' + item.id + '/historico'])"><i class="bi-clipboard2-check" aria-hidden="true"></i>Cambiar histórico</button></li>
                                    @if (puedeRestablecer) {
                                        <li><button type="button" class="dropdown-item" data-testid="accion-claves" (click)="viewMode = ViewModeAsociado.CHANGE_PASSWORD"><i class="bi bi-key-fill" aria-hidden="true"></i>Cambiar claves</button></li>
                                    }
                                </ul>
                            </div>
                        }
                    </div>
                </div>
                @if (viewMode !== ViewModeAsociado.CHANGE_PASSWORD) {
                    <div class="tabs" role="tablist" aria-label="Secciones de la ficha" appTabsNav>
                        <button type="button" role="tab" class="tab" id="tab-personal" [attr.aria-selected]="viewMode === ViewModeAsociado.PERSONAL" [attr.tabindex]="viewMode === ViewModeAsociado.PERSONAL ? 0 : -1" (click)="handleClick(ViewModeAsociado.PERSONAL)">Información personal</button>
                        <button type="button" role="tab" class="tab" id="tab-contacto" [attr.aria-selected]="viewMode === ViewModeAsociado.CONTACT" [attr.tabindex]="viewMode === ViewModeAsociado.CONTACT ? 0 : -1" (click)="handleClick(ViewModeAsociado.CONTACT)">Contacto</button>
                        <button type="button" role="tab" class="tab" id="tab-asociaciones" [attr.aria-selected]="viewMode === ViewModeAsociado.ASOCIACIONES" [attr.tabindex]="viewMode === ViewModeAsociado.ASOCIACIONES ? 0 : -1" (click)="handleClick(ViewModeAsociado.ASOCIACIONES)">Asociaciones</button>
                        <button type="button" role="tab" class="tab" id="tab-historico" [attr.aria-selected]="viewMode === ViewModeAsociado.HISTORICO" [attr.tabindex]="viewMode === ViewModeAsociado.HISTORICO ? 0 : -1" (click)="handleClick(ViewModeAsociado.HISTORICO)">Histórico</button>
                    </div>
                }
            </section>

            @if (viewMode === ViewModeAsociado.CHANGE_PASSWORD) {
                @if (puedeRestablecer) {
                    <app-restablecer-password tipo="persona" [cuenta]="{ id: item.id, nombre: ((item.nombre || '') + ' ' + (item.apellidos || '')).trim() }"></app-restablecer-password>
                }
            }
            @if (viewMode === ViewModeAsociado.PERSONAL) {
                <div role="tabpanel" aria-labelledby="tab-personal"><dl class="data-grid">
                    <div class="data-item">
                        <dt><i class="bi bi-person-vcard" aria-hidden="true"></i>NIF</dt>
                        <dd [class.is-empty]="item.nif === null">{{ item.nif !== null ? item.nif : 'Sin definir' }}</dd>
                    </div>
                    <div class="data-item">
                        <dt><i class="bi bi-cake2-fill" aria-hidden="true"></i>Fecha de nacimiento</dt>
                        <dd [class.is-empty]="item.fecha_nacimiento === null">{{ item.fecha_nacimiento !== null ? item.fecha_nacimiento : 'Sin definir' }}</dd>
                    </div>
                </dl></div>
            }
            @if (viewMode === ViewModeAsociado.CONTACT) {
                <div role="tabpanel" aria-labelledby="tab-contacto"><dl class="data-grid">
                    <div class="data-item">
                        <dt><i class="bi bi-phone-fill" aria-hidden="true"></i>Teléfono</dt>
                        <dd [class.is-empty]="item.telefono === null">{{ item.telefono !== null ? item.telefono : 'Sin definir' }}</dd>
                    </div>
                    <div class="data-item">
                        <dt><i class="bi bi-envelope-fill" aria-hidden="true"></i>e-mail</dt>
                        <dd [class.is-empty]="item.email === null">{{ item.email !== null ? item.email : 'Sin definir' }}</dd>
                    </div>
                    <div class="data-item">
                        <dt><i class="bi bi-pin-map-fill" aria-hidden="true"></i>Dirección</dt>
                        <dd [class.is-empty]="item.direccion === null">{{ item.direccion !== null ? item.direccion : 'Sin definir' }}</dd>
                    </div>
                    <div class="data-item">
                        <dt><i class="bi bi-geo-fill" aria-hidden="true"></i>Código postal</dt>
                        <dd [class.is-empty]="item.codigo_postal === null">{{ item.codigo_postal !== null ? item.codigo_postal : 'Sin definir' }}</dd>
                    </div>
                </dl></div>
            }
            @if (viewMode === ViewModeAsociado.ASOCIACIONES) {
                <section class="panel" role="tabpanel" aria-labelledby="tab-asociaciones">
                    <div class="panel-head">
                        <h2 class="panel__title">Asociaciones</h2>
                        <div class="search-field">
                            <i class="bi bi-search" aria-hidden="true"></i>
                            <input type="search" class="form-control" aria-label="Buscar asociación" [formControl]="searchControl" autocomplete="off" placeholder="Nombre, número o lema de la asociación" (input)="filterItems($event)">
                        </div>
                    </div>
                    <app-listado
                        [marginPagination]="false"
                        [showFilter]="false"
                        [items]="asociacionesToShow"
                        [type]="ItemType.ASOCIACIONES"
                        (openItem)="null"
                    ></app-listado>
                </section>
            }
            @if (viewMode === ViewModeAsociado.HISTORICO) {
                <section class="panel" role="tabpanel" aria-labelledby="tab-historico">
                    <div class="panel-head"><h2 class="panel__title">Histórico</h2></div>
                    <app-listado
                        [marginPagination]="false"
                        [showFilter]="false"
                        [items]="cargos"
                        [type]="ItemType.HISTORICOASOCIADO"
                        (openItem)="null"
                    ></app-listado>
                </section>
            }
        }
    </div>
}
